import React, { FC } from 'react'

type CookiesSingleSettingProps = {
  children: React.ReactNode
}

export const CookiesSingleSetting: FC<CookiesSingleSettingProps> = ({ children }) => {
  return <div className="flex flex-row items-start justify-between py-4">{children}</div>
}
